import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { v4 } from "uuid";
import ImageLoader from "../../comm/global/components/ImageLoader";
import Tab1Content from "./Tab1Content";
const Tab1 = ({ addModalType }) => {
    useEffect(() => {
    }, [])
    
    return (
        <Tab1Content addModalType={addModalType} />
    );
}

export default Tab1;